import React, { useState } from "react";
import queryString from 'query-string';

import BulkShareModal from '@components/show_page/bulk_actions/BulkShareModal';

function ShareManifestEdit(props) {
  const defaultModalState = queryString.parse(window.location.search).show_edit_share_mode === "true";
  const [openModal, toggleModal] = useState(defaultModalState);

  return (
    <React.Fragment>
      <div className="s-share-manifest-edit-container no-print">
        <button
          className="share-manifest-edit-button"
          onClick={() => toggleModal(!openModal)}
          type="button"
        >
          <span className="bff-edit-asset" />
          Edit share link
        </button>
        { openModal ? <BulkShareModal {...props} /> : null }
      </div>
    </React.Fragment>
  );
}

export default ShareManifestEdit;
